'use client'
import { AuthorCardProps, NormalizedSection } from '@/types'

import { AuthorCard, Section } from '@dynamo-caffeina-dev/airc-ui-kit'

export interface RecipeAuthorProps extends NormalizedSection {
  modelledContent: {
    authorCard: AuthorCardProps
  }
}

function RecipeAuthor({ modelledContent, ...props }: RecipeAuthorProps) {
  const { authorCard } = modelledContent
  const authorCardProps = {
    authorTitle: authorCard.title,
    authorSubtitle: authorCard.subtitle,
    authorImage: authorCard.image.url,
    children: authorCard.description,
    authorHref: authorCard.href,
  }
  return (
    <Section className='section-recipe-author'>
      <AuthorCard
        className={'section-recipe-author__card'}
        {...authorCardProps}
      />
    </Section>
  )
}

export default RecipeAuthor
